import {createReducer} from "@reduxjs/toolkit";
import {FETCHING_STATE} from "../../shared/utils";

import {
    LIST_DATA_FETCH_FAILED_ACTION_TYPE,
    LIST_DATA_FETCHED_ACTION_TYPE,
    LIST_DATA_FETCH_ACTION_TYPE,
    ITEM_DISABLED_ACTION_TYPE,
    ITEM_LOADING_START_ACTION_TYPE,
    ITEM_LOADING_END_ACTION_TYPE,
} from "../actions/actions";


const initialState = {
    fetchingState: '',
    items: [],
    declineReasons: {}
};

export default createReducer(initialState, {
    [LIST_DATA_FETCH_ACTION_TYPE]: (state, {payload}) => {
        state.fetchingState = FETCHING_STATE.PENDING;
    },
    [LIST_DATA_FETCHED_ACTION_TYPE]: (state, {payload}) => {
        state.fetchingState = FETCHING_STATE.SUCCESS;
        state.items = payload.data || [];
        state.declineReasons = payload.declineReasons || {}
    },
    [LIST_DATA_FETCH_FAILED_ACTION_TYPE]: (state) => {
        state.fetchingState = FETCHING_STATE.ERROR;
    },
    [ITEM_DISABLED_ACTION_TYPE]: (state, {payload}) => {
        const item = state.items.find(i => i.id === payload.itemId);

        if (item) {
            item.disabled = true;

            const mapping = {
                'accept': 'accepted',
                'decline': 'declined',
                'change': 'changed'
            };

            item.action = mapping[payload.actionType] || payload.actionType;
            item.lastActionDate = new Date().toISOString();
        }
    },
    [ITEM_LOADING_START_ACTION_TYPE]: (state, {payload}) => {
        const item = state.items.find(i => i.id === payload.itemId);

        if (item) {
            item.loading = true;
        }
    },
    [ITEM_LOADING_END_ACTION_TYPE]: (state, {payload}) => {
        const item = state.items.find(i => i.id === payload.itemId);

        if (item) {
            item.loading = false;
        }
    }
});

// selectors
export const getFetchingState = (state) => state.fetchingState;
export const getItems = (state) => state.items;
export const getDeclineReasons = (state) => state.declineReasons;
